import { render, staticRenderFns } from "./IconDanish.vue?vue&type=template&id=13049b06"
import script from "./IconDanish.vue?vue&type=script&lang=js"
export * from "./IconDanish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports